import category1 from "../assets/icon/category-1.png";
import category2 from "../assets/icon/category-2.png";
import category3 from "../assets/icon/category-3.png";
import category4 from "../assets/icon/category-4.png";
import category5 from "../assets/icon/category-5.png";
import category6 from "../assets/icon/category-6.png";
import category7 from "../assets/icon/category-7.png";
import category8 from "../assets/icon/category-8.png";
import category9 from "../assets/icon/category-9.png";
import category10 from "../assets/icon/category-10.png";
import category11 from "../assets/icon/category-11.png";
import category12 from "../assets/icon/category-12.png";
import category13 from "../assets/icon/category-13.png";
import category14 from "../assets/icon/category-14.png";
import category15 from "../assets/icon/category-15.png";
import category16 from "../assets/icon/category-16.png";
import category17 from "../assets/icon/category-17.png";
import category18 from "../assets/icon/category-18.png";
export const CategoriesData = [
  {
    name: "Fish & Meat",
    icon: category1,
    path:"fish--meat",
    subCategories: [
      { name: "Fish", path: "fish" },
      { name: "Meat", path: "meat" },
    ],
  },
  {
    name: "Fruits & Vegetable",
    icon: category2,
    path:"fruits--vegetable",
    subCategories: [
      { name: "Dry Frutis", path: "dry-frutis" },
      { name: "Fresh Frutis", path: "fresh-frutis" },
      { name: "Fresh Vegetable", path: "fresh-vegetable" },
    ],
  },
  {
    name: "Fresh Seafood",
    icon: category3,
    path:"fresh--seafood",
    subCategories: [{ name: "Fresh Seafood", path: "fresh-seafood" }],
  },
  {
    name: "Cooking Essentials",
    icon: category4,
    path:"cooking--essentials",
    subCategories: [
      { name: "Oil", path: "oil" },
      { name: "Rice", path: "rice" },
      { name: "Flour", path: "flour" },
    ],
  },
  {
    name: "Breakfast",
    icon: category5,
    path:"breakfast",
    subCategories: [
      { name: "Bread", path: "bread" },
      { name: "Cereal", path: "cereal" },
    ],
  },
  {
    name: "Drinks",
    icon: category6,
    path:"drinks",
    subCategories: [
      { name: "Tea", path: "tea" },
      { name: "Water", path: "water" },
      { name: "Juice", path: "juice" },
    ],
  },
  {
    name: "Milk & Dairy",
    icon: category7,
    path:"milk--dairy",
    subCategories: [
      { name: "Dairy", path: "dairy" },
      { name: "Ice Cream", path: "ice-cream" },
      { name: "Butter & Ghee", path: "butter--ghee" },
    ],
  },
  {
    name: "Organic Food",
    icon: category8,
    path:"organic--food",
    subCategories: [{ name: "Organic Food", path: "organic-food" }],
  },
  {
    name: "Honey",
    icon: category9,
    path:"honey",
    subCategories: [{ name: "Honey", path: "honey" }],
  },
  {
    name: "Sauces & Pickles",
    icon: category10,
    path:"sauces--pickles",
    subCategories: [
      { name: "Sauces", path: "sauces" },
      { name: "Pickles & Condiments", path: "pickles--condiments" },
    ],
  },
  {
    name: "Jam & Jelly",
    path:"jam--jelly",
    icon: category11,
    subCategories: [{ name: "Jam & Jelly", path: "jam--jelly" }],
  },
  {
    name: "Snack & Instant",
    path:"snack--instant",
    icon: category12,
    subCategories: [
      { name: "Chocolate", path: "chocolate" },
      { name: "Chips & Nuts", path: "chips--nuts" },
      { name: "Canned Food", path: "canned-food" },
    ],
  },
  {
    name: "Biscuits & Cakes",
    icon: category13,
    path:"biscuits--cakes",
    subCategories: [
      { name: "Cakes", path: "cakes" },
      { name: "Biscuits", path: "biscuits" },
    ],
  },
  {
    name: "Household Tools",
    icon: category14,
    path:"household--tools",
    subCategories: [
      { name: "Cleaner", path: "cleaner" },
      { name: "Laundry", path: "laundry" },
      { name: "Air Freshener", path: "air--freshener" },
    ],
  },
  {
    name: "Baby Care",
    icon: category15,
    path:"baby--care",
    subCategories: [
      { name: "Baby Food", path: "baby-food" },
      { name: "Baby Accessories", path: "baby-accessories" },
    ],
  },
  {
    name: "Pet Care",
    icon: category16,
    path:"pet--care",
    subCategories: [
      { name: "Cat Care", path: "cat-care" },
      { name: "Dog Care", path: "dog-care" },
      { name: "Bird Care", path: "bird-care" },
    ],
  },
  {
    name: "Beauty & Health",
    icon: category17,
    path:"beauty--health",
    subCategories: [
      { name: "Bath", path: "bath" },
      { name: "Cosmetics", path: "cosmetics" },
      { name: "Oral Care", path: "oral-care" },
    ],
  },
  {
    name: "Sports & Fitness",
    path:"sports--fitness",
    icon: category18,
    subCategories: [
      { name: "Sports", path: "sports" },
      { name: "Fitness", path: "fitness" },
     
    ],
  },
];
